<main class="main">
  <router-outlet></router-outlet>
  <p-toast></p-toast>
</main>
